// helpers/rutaMetodos.js
import axios from "axios";

// === Base San Pancracio (como en tus otros helpers) ===
const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial (evita //dobles)
const p = (s) => String(s || "").replace(/^\/+/, "");

// Header con token (compat: token/Authorization)
const auth = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt") ||
    "";
  return token
    ? { headers: { token, Authorization: `Bearer ${token}` } }
    : {};
};

// helper para headers extra (ej: content-type) + auth
const withHeaders = (extra = {}) => {
  const base = auth();
  return {
    headers: {
      ...(base.headers || {}),
      ...extra,
    },
  };
};

// ----------------------- normalizadores -----------------------
const toISO = (d) => (d ? new Date(d).toISOString() : undefined);

const toApiTipo = (t) => {
  const s = String(t || "").toLowerCase();
  if (s === "efectivo") return "efectivo";
  if (s === "transferencia") return "transferencia";
  if (s === "icheq" || s === "echeq") return "echeq";
  // En la UI usamos "CHEQUE" genérico; en API suele ser "cheque_tercero"
  if (
    s === "cheque" ||
    s === "cheque_tercero" ||
    s === "cheque propio" ||
    s === "cheque_propio"
  )
    return "cheque_tercero";
  return "efectivo";
};

// ----------------------- METODOS (CRUD) -----------------------
export const getMetodos = async () => {
  try {
    const { data } = await API.get(p("metodos"), auth());
    // esperado: { ok, metodos: [...] }
    if (data?.ok && Array.isArray(data.metodos)) return data.metodos;
    // fallback por si el back devuelve array plano
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("❌ Error en getMetodos:", error);
    return [];
  }
};

export const getMetodoById = async (id) => {
  try {
    const { data } = await API.get(p(`metodos/${id}`), auth());
    return data; // { ok, metodo }
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data || "Error al obtener método",
    };
  }
};

export const postMetodo = async (metodoData) => {
  try {
    const { data } = await API.post(
      p("metodos"),
      metodoData,
      withHeaders({ "Content-Type": "application/json" })
    );
    return data; // { ok, metodo }
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data || "Error al crear método",
    };
  }
};

export const putMetodo = async (id, metodoData) => {
  try {
    const { data } = await API.put(
      p(`metodos/${id}`),
      metodoData,
      withHeaders({ "Content-Type": "application/json" })
    );
    return data; // { ok, metodo }
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data || "Error al actualizar método",
    };
  }
};

export const deleteMetodo = async (id) => {
  try {
    const { data } = await API.delete(p(`metodos/${id}`), auth());
    return data; // { ok, ... }
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data || "Error al eliminar método",
    };
  }
};

// ----------------------- ORDEN DE COBRO -----------------------
export const postOrdenCobro = async (oc) => {
  // Normalización de medios y retenciones
  const payload = {
    ...oc,
    medios: (oc.medios || []).map((m) => ({
      ...m,
      tipo: toApiTipo(m.tipo),
      importe: Number(m.importe || 0),
      fecha: toISO(m.fecha),
      fechaValor: toISO(m.fechaValor),
      fechaPagoDiferido: toISO(m.fechaPagoDiferido),
      fechaLiquidacion: toISO(m.fechaLiquidacion),
    })),
    retenciones: (oc.retenciones || []).map((r) => ({
      ...r,
      importe: Number(r.importe || 0),
      fecha: toISO(r.fecha),
    })),
  };

  try {
    const { data } = await API.post(
      p("ordencobro"),
      payload,
      withHeaders({ "Content-Type": "application/json" })
    );
    return data; // { ok, oc }
  } catch (error) {
    const data = error?.response?.data;
    console.error("❌ postOrdenCobro error:", data || error);
    return { ok: false, error: data || "Error al guardar la orden" };
  }
};
